// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".tooltip-criterion.tooltip.b-tooltip{opacity:1}.tooltip-criterion .arrow:before{border-bottom-color:#3b3e66}.tooltip-criterion .tooltip-inner{background-color:#3b3e66;box-shadow:none;max-width:472px;white-space:pre-line;word-break:break-word;text-align:left}", ""]);
// Exports
module.exports = exports;
